module.exports = __webpack_public_path__ + "static/img/aboutbanner.5510703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutbanner.png
// module id = 213
// module chunks = 1